module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/広角＋望遠＋高画素のトリプルカメラ.67708cca.png";